import { Injectable } from '@angular/core';
import { RestApi } from 'app/auth/rest.api';
import { Observable } from 'rxjs';

@Injectable()
export class SequenceService {
  sequencesUrl = 'api/Sequences';
  constructor(private _sequencesHttp: RestApi) { }

  getSequences(): Observable<any> {
    return this._sequencesHttp.get(`${this.sequencesUrl}/sequences-list`);
  }

  updateSequence(sequence: any): Observable<any> {
    return this._sequencesHttp.post(`${this.sequencesUrl}/update-sequence`, sequence);
  }
}
